module.exports = __webpack_public_path__ + "static/media/7.9d0a5593.JPG";